export function repiteEstructura() {
  throw new Error('repiteEstructura es una directiva de preproceso y no debe llegar a ejecución')
}
